// The Comic Machine - Text Engine UI

var TextController = (function() {

  var config = {};

  // Handles UI and DOM manipulation
  var UI = {

    // DOM elements to manage
    elements: {},

    // References to current state
    options: null,
    layer: null,
    canvas: null,
    context: null,
    instance: null,

    // Flag for active state
    active: false,

    // Events scoped to this UI
    events: new Events(),

    // Initialize the UI and DOM manager
    initialize: function(options, toggle) {

      options = options || {};

      if (
        !options.layer
        || !options.layer.canvas
        || !options.layer.canvas.context
      ) {
        return;
      }

      Events.global.emit("tcm.layer.text", true);

      options.layer.canvas.setScale(2); // HACK
      options.layer.canvas.setSize(Canvas.size.width, Canvas.size.height);

      UI.instance = options;

      if (!UI.elements.container) {
        // DOM elements to manage
        UI.elements = {
          container: document.querySelector(".text-configuration"),
          close: document.querySelector(".text-configuration .close"),
        };
        // Bind handlers to events
        UI.bindEvents();
        UI.configure.init();
      }

      UI.configure.load();

      if (toggle) {
        UI.toggle(true);
      }

    },

    // Bind handlers to events
    bindEvents: function() {

      // Handle on click of close text editor
      attachHandler(UI.elements.close, UI.save);
      Events.global.on("tcm.layer.text.close", UI.save);

      var documentElement = document.documentElement;
      var initialPosition = new Vector2();
      var currentPosition = new Vector2();
      var offsetPosition = new Vector2();
      var isDragging = false;

      documentElement.addEventListener("mousedown", function(event) {
        if (event.target !== canvas) {
          return;
        }
        isDragging = true;
        var offset = Canvas.size.offset;
        var x = event.clientX - canvas.getBoundingClientRect().left - offset;
        var y = event.clientY - canvas.getBoundingClientRect().top - offset;
        initialPosition = new Vector2(x, y);
        currentPosition = new Vector2(x, y);
        offsetPosition = new Vector2(0, 0);
        TextController.events.emit("canvas-mousedown", {
          initialPosition: initialPosition,
          currentPosition: currentPosition,
          offsetPosition: offsetPosition,
        });
      });

      documentElement.addEventListener("mousemove", function(event) {
        var offset = Canvas.size.offset;
        var x = event.clientX - canvas.getBoundingClientRect().left - offset;
        var y = event.clientY - canvas.getBoundingClientRect().top - offset;
        currentPosition = new Vector2(x, y);
        offsetPosition = !isDragging ? offsetPosition : new Vector2(
          currentPosition.x - initialPosition.x,
          currentPosition.y - initialPosition.y
        );
        TextController.events.emit("canvas-mousemove", {
          isDragging: isDragging,
          initialPosition: initialPosition,
          currentPosition: currentPosition,
          offsetPosition: offsetPosition,
        });
      });

      documentElement.addEventListener("mouseup", function(event) {
        if (!isDragging) {
          return;
        }
        var offset = Canvas.size.offset;
        var x = event.clientX - canvas.getBoundingClientRect().left - offset;
        var y = event.clientY - canvas.getBoundingClientRect().top - offset;
        currentPosition = new Vector2(x, y);
        offsetPosition = !isDragging ? offsetPosition : new Vector2(
          currentPosition.x - initialPosition.x,
          currentPosition.y - initialPosition.y
        );
        TextController.events.emit("canvas-mouseup", {
          isDragging: isDragging,
          initialPosition: initialPosition,
          currentPosition: currentPosition,
          offsetPosition: offsetPosition,
        });
        isDragging = false;
      });

    },

    // Configures the text element with the specified data
    configure: {

      // Method to initialize text configuration
      init: function() {

        this.textValue();

        this.fontSize();
        this.fontFace();

        this.textHorizontalAlign();
        this.textVerticalAlign();
        this.textOverflow();
        this.textLeading();
        this.textPadding();

        this.shapeStyle();
        this.tailStyle();
        this.tailWidth();
        this.colorStyle();

        this.borderSize();
        this.borderStyle();

        this.createNumericOptions("font-size", 0, 150, "px");
        this.createNumericOptions("text-padding", 0, 150, "px");
        this.createNumericOptions("text-leading", -50, 150, "px");
        this.createNumericOptions("border-size", 0, 50, "px");
        this.createNumericOptions("tail-width", 0, 100);

      },

      // Method to load text configuration
      load: function() {

        this.textValue(UI.instance.value);

        this.fontSize(UI.instance.font.size);
        this.fontFace(UI.instance.font.face);

        this.textHorizontalAlign(UI.instance.font.alignment.horizontal);
        this.textVerticalAlign(UI.instance.font.alignment.vertical);
        this.textOverflow(UI.instance.font.overflow);
        this.textLeading(UI.instance.font.leading);
        this.textPadding(UI.instance.font.padding);

        this.shapeStyle(UI.instance.shape.outline.id);
        this.tailStyle(UI.instance.shape.tail.type);
        this.tailWidth(UI.instance.shape.tail.width);
        this.colorStyle(UI.instance.style);

        this.borderSize(UI.instance.shape.border.size);
        this.borderStyle(UI.instance.shape.border.dash);

      },

      // Method to create select option elements
      createNumericOptions: function(id, min, max, suffix, prefix) {

        prefix = prefix || "";
        suffix = suffix || "";

        var selector = "select[data-configure='" + id + "']";
        var element = document.querySelector(selector);
        var children = document.createDocumentFragment();
        var option = null;

        var index = min;
        var length = max;

        for (; index <= length; index++) {
          option = document.createElement("option");
          option.value = index;
          option.innerHTML = prefix + index + suffix;
          children.appendChild(option);
        }

        element.appendChild(children);

      },

      // Method to handle the text area value
      textValue: function(value) {

        var input = document.getElementById("text-input");

        if (!input) {
          return;
        }

        if (value) {
          input.value = value;
        } else {
          input.onkeyup = UI.configure.textValueUpdate;
          input.onchange = UI.configure.textValueUpdate;
        }

      },

      // Method to handle updating the text value
      textValueUpdate: function(event) {

        var value = this.value;

        UI.instance.value = value;
        UI.instance.updateCanvas();

      },

      // Method to handle text font size
      fontSize: function(value) {

        var query = "select[data-configure='font-size']";
        var select = document.querySelector(query);

        if (!select) {
          return;
        }

        if (value) {
          select.value = value;
        } else {
          select.onchange = function(event) {
            UI.instance.font.size = window.parseInt(this.value, 10);
            UI.instance.updateCanvas();
          };
        }

      },

      // Method to handle text font face
      fontFace: function(value) {

        var query = "select[data-configure='font-face']";
        var select = document.querySelector(query);

        if (!select) {
          return;
        }

        if (value) {
          select.value = value;
        } else {
          select.onchange = function(event) {
            UI.instance.font.face = this.value;
            UI.instance.updateCanvas();
          };
        }

      },

      // Method to handle text horizontal align
      textHorizontalAlign: function(value) {

        var query = "select[data-configure='font-align-horizontal']";
        var select = document.querySelector(query);

        if (!select) {
          return;
        }

        if (value) {
          select.value = value;
        } else {
          select.onchange = function(event) {
            var align = TextElement.HorizontalAlignment[this.value];
            UI.instance.font.alignment.horizontal = align;
            UI.instance.updateCanvas();
          };
        }

      },

      // Method to handle text vertical align
      textVerticalAlign: function(value) {

        var query = "select[data-configure='font-align-vertical']";
        var select = document.querySelector(query);

        if (!select) {
          return;
        }

        if (value) {
          select.value = value;
        } else {
          select.onchange = function(event) {
            var align = TextElement.VerticalAlignment[this.value];
            UI.instance.font.alignment.vertical = align;
            UI.instance.updateCanvas();
          };
        }

      },

      // Method to handle text overflow options
      textOverflow: function(value) {

        var query = "select[data-configure='text-overflow']";
        var select = document.querySelector(query);

        if (!select) {
          return;
        }

        if (value) {
          select.value = value;
        } else {
          select.onchange = function(event) {
            UI.instance.font.overflow = TextElement.Overflow[this.value];
            UI.instance.updateCanvas();
          };
        }
      },

      // Method to handle text leading / line height
      textLeading: function(value) {

        var query = "select[data-configure='text-leading']";
        var select = document.querySelector(query);

        if (!select) {
          return;
        }

        if (value) {
          select.value = value;
        } else {
          select.onchange = function(event) {
            UI.instance.font.leading = window.parseInt(this.value, 10);
            UI.instance.updateCanvas();
          };
        }

      },

      // Method to handle text panel padding
      textPadding: function(value) {

        var query = "select[data-configure='text-padding']";
        var select = document.querySelector(query);

        if (!select) {
          return;
        }

        if (value) {
          select.value = value;
        } else {
          select.onchange = function(event) {
            UI.instance.font.padding = window.parseInt(this.value, 10);
            UI.instance.updateCanvas();
          };
        }

      },

      // Method to handle shape options
      shapeStyle: function(value) {

        var query = "select[data-configure='shape-style']";
        var select = document.querySelector(query);

        if (!select) {
          return;
        }

        if (value) {
          select.value = value;
        } else {
          select.onchange = function(event) {
            if (ShapeElement.bubbles()[this.value]) {
              UI.instance.shape.outline = ShapeElement.bubbles()[this.value];
              UI.instance.updateCanvas();
              // UI.instance.shape.resizeShape(new Vector2(
              //   UI.instance.shape.bounds.width,
              //   UI.instance.shape.bounds.height
              // ));
              // UI.instance.updateCanvas();
            }
          };
        }

      },

      // Method to handle shape tail style
      tailStyle: function(value) {

        var query = "select[data-configure='tail-style']";
        var select = document.querySelector(query);

        if (!select) {
          return;
        }

        if (value) {
          select.value = value;
        } else {
          select.onchange = function(event) {
            UI.instance.shape.tail.type = this.value;
            if (this.value === "straight") {
              UI.instance.shape.tail.control = new Vector2();
            } else if (this.value === "curved" &&
              UI.instance.shape.tail.control.x === 0 &&
              UI.instance.shape.tail.control.y === 0
            ) {
              UI.instance.shape.tail.control = new Vector2(15, -20);
            }
            UI.instance.updateCanvas();
          };
        }

      },

      // Method to handle shape tail width
      tailWidth: function(value) {

        var query = "select[data-configure='tail-width']";
        var select = document.querySelector(query);

        if (!select) {
          return;
        }

        if (value) {
          select.value = value;
        } else {
          select.onchange = function(event) {
            UI.instance.shape.tail.width = window.parseInt(this.value, 10);
            UI.instance.updateCanvas();
          };
        }

      },

      // Method to handle shape color style
      colorStyle: function(value) {

        var query = "select[data-configure='color-style']";
        var select = document.querySelector(query);

        if (!select) {
          return;
        }

        if (value) {
          if (value === UI.instance) {

          } else {
            select.value = value;
          }
        } else {
          select.onchange = function(event) {
            if (this.value === "light") {
              UI.instance.font.color = "rgba(0, 0, 0, 1)";
              UI.instance.shape.color = "rgba(255, 255, 255, 1)";
              UI.instance.shape.border.color = "rgba(0, 0, 0, 1)";
            } else if (this.value === "dark") {
              UI.instance.font.color = "rgba(255, 255, 255, 1)";
              UI.instance.shape.color = "rgba(0, 0, 0, 1)";
              UI.instance.shape.border.color = "rgba(255, 255, 255, 1)";
            } else if (this.value === "blank-light") {
              UI.instance.font.color = "rgba(0, 0, 0, 1)";
              UI.instance.shape.color = "rgba(0, 0, 0, 0)";
              UI.instance.shape.border.color = "rgba(0, 0, 0, 0)";
            } else if (this.value === "blank-dark") {
              UI.instance.font.color = "rgba(255, 255, 255, 1)";
              UI.instance.shape.color = "rgba(0, 0, 0, 0)";
              UI.instance.shape.border.color = "rgba(255, 255, 255, 0)";
            }
            UI.instance.style = this.value;
            UI.instance.updateCanvas();
          };
        }

      },

      // Method to handle shape border size
      borderSize: function(value) {

        var query = "select[data-configure='border-size']";
        var select = document.querySelector(query);

        if (!select) {
          return;
        }

        if (value || value === 0) {
          select.value = value;
        } else {
          select.onchange = function(event) {
            UI.instance.shape.border.size = window.parseInt(this.value, 10);
            UI.instance.updateCanvas();
          };
        }

      },

      // Method to handle shape border style
      borderStyle: function(value) {

        var query = "select[data-configure='border-style']";
        var select = document.querySelector(query);

        if (!select) {
          return;
        }

        if (value) {
          if (value[0] === 0 && value[1] === 0) {
            value = "solid";
          } else if (value[0] === 2 && value[1] === 3) {
            value = "dotted";
          } else if (value[0] === 7 && value[1] === 4) {
            value = "dashed";
          } else {
            value = "none";
          }
          select.value = value;
        } else {
          select.onchange = function(event) {
            if (this.value === "none") {
              UI.instance.shape.border.size = 0;
              UI.configure.borderSize(0);
            } else {
              if (this.value === "solid") {
                UI.instance.shape.border.dash = [0, 0];
              } else if (this.value === "dotted") {
                UI.instance.shape.border.dash = [2, 3];
              } else if (this.value === "dashed") {
                UI.instance.shape.border.dash = [7, 4];
              }
              if (UI.instance.shape.border.size === 0) {
                UI.instance.shape.border.size = 3;
                UI.configure.borderSize(3);
              }
            }
            UI.instance.updateCanvas();
          };
        }

      },

    },

    // Method to toggle the text engine active state
    toggle: function(active) {

      if (active === true || active === false) {
        UI.active = active;
      } else {
        UI.active = !UI.active;
      }

      UI.instance.editing = UI.active;
      UI.instance.updateCanvas();

      UI.elements.container.style.display = UI.active ? "block" : "none";

    },

    // Save the text layer changes
    save: function(event) {

      UI.instance.generateImage(function(image, data) {

        UI.instance.editing = false;
        UI.instance.updateCanvas();
        UI.instance.layer.content = UI.instance.generateStaticCanvas();

        UI.instance.layer.asset = {
          image: image,
          data: data
        };

        if (!UI.instance.layer.transition.start.width) {
          UI.instance.layer.transition.start.width = UI.instance.layer.canvas.element.width;
        }
        if (!UI.instance.layer.transition.start.height) {
          UI.instance.layer.transition.start.height = UI.instance.layer.canvas.element.height;
        }
        if (!UI.instance.layer.transition.end.width) {
          UI.instance.layer.transition.end.width = UI.instance.layer.canvas.element.width;
        }
        if (!UI.instance.layer.transition.end.height) {
          UI.instance.layer.transition.end.height = UI.instance.layer.canvas.element.height;
        }

        Comic.renderPage();

        UI.instance.layer.updateThumbnail();

        Events.global.emit("tcm.layer.update");

        UI.toggle(false);

      });

    },

  };

  // Public / exposed object
  return UI;

})();
